import './abritin/style';
import FormStructure from './abritin/form_structure';

export default FormStructure;